import { Trans } from "gatsby-plugin-react-i18next"
import styled from "styled-components"

import LinkButton from "components/buttons/LinkButton"
import Kicker, { KickerTextType } from "components/TextElements/Kicker"
import colors from "styles/colors"
import easing from "styles/easing"
import media from "styles/media"
import text from "styles/text"
import { Opacity } from "utils/functions"

interface Props {
  info: {
    icon: KickerTextType
    title: string
    body: string
    link: string
    border?: boolean
  }
}

export default function GeneralCard({ info }: Props) {
  return (
    <Wrapper outerBorder={info.border}>
      <Kicker kickerIcon={info.icon} />
      <Title>{info.title}</Title>
      <Body>{info.body}</Body>
      {info.link && (
        <LinkButton blue link={info.link}>
          <Trans>Learn More</Trans>
        </LinkButton>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ outerBorder: boolean | undefined }>`
  box-sizing: border-box;
  div > {
    //kicker
    margin-bottom: 1.205vw;
  }
  img {
    width: 2.108vw;
    height: 2.108vw;
  }
  ${media.fullWidth} {
    width: 440px;
    height: 360px;
    padding: 40px;
    box-shadow: 20px 40px 40px rgba(11, 35, 115, 0);
    > div {
      //kicker
      margin-bottom: 20px;
    }
    img {
      width: 35px;
      height: 35px;
    }
  }
  ${media.tablet} {
    border: ${props =>
      props.outerBorder ? `0.098vw solid ${colors.blue10}` : "none"};
    width: 39.746vw;
    height: initial;
    padding: 3.906vw;
    border-radius: 0.977vw;
    div > {
      //kicker
      margin-bottom: 1.953vw;
    }
    img {
      width: 3.418vw;
      height: 3.418vw;
    }
  }
  ${media.mobile} {
    border: 0.267vw solid ${colors.blue10};
    width: 89.333vw;
    height: initial;
    padding: 8vw;
    border-radius: 2.667vw;
    div > {
      //kicker
      margin-bottom: 5.333vw;
    }
    img {
      width: 9.333vw;
      height: 9.333vw;
    }
  }
  width: 26.506vw;
  height: 21.687vw;
  padding: 2.41vw;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  transition: 0.3s;
  background-color: ${Opacity(colors.white, 0)};
  box-shadow: 1.205vw 2.41vw 2.41vw rgba(11, 35, 115, 0);
  transition-timing-function: cubic-bezier(${easing.button});
  ${media.hover} {
    :hover {
      border-radius: 0.602vw;
      ${media.fullWidth} {
        border-radius: 10px;
        box-shadow: 20px 40px 40px rgba(11, 35, 115, 0.075);
        border-radius: 10px;
      }
      ${media.tablet} {
        background-color: initial;
        box-shadow: none;
        border-radius: 0.977vw;
      }
      ${media.mobile} {
        background-color: initial;
        box-shadow: none;
        border-radius: 2.667vw;
      }
      background-color: ${colors.white};
      box-shadow: 1.205vw 2.41vw 2.41vw rgba(11, 35, 115, 0.075);
    }
  }
`

const Title = styled.div`
  ${text.h5}
  margin-bottom: 0;
  color: ${colors.blue800};
  ${media.fullWidth} {
  }
  ${media.tablet} {
  }
  ${media.mobile} {
    ${text.h6}
  }
`

const Body = styled.div`
  ${text.bodyR}
  color: ${colors.blue200};
  margin-bottom: 1.205vw;
  ${media.fullWidth} {
    margin-bottom: 20px;
  }
  ${media.tablet} {
    margin-top: 1.953vw;
    margin-bottom: 1.953vw;
    font-size: 1.54vw;
  }
  ${media.mobile} {
    ${text.bodyS}
    margin-top: 5.333vw;
    margin-bottom: 5.333vw;
    font-size: 3.58vw !important;
  }
`
